// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"c9fbf54e","221":"3b2e38ec","236":"7113aece","378":"df919dbe","940":"0670c352"}[chunkId] + ".chunk.js";
};